import { render, staticRenderFns } from "./PromotionsWindow.vue?vue&type=template&id=1701c5be&scoped=true&"
import script from "./PromotionsWindow.vue?vue&type=script&lang=js&"
export * from "./PromotionsWindow.vue?vue&type=script&lang=js&"
import style0 from "./PromotionsWindow.vue?vue&type=style&index=0&id=1701c5be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1701c5be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VRow,VTextField})
